import type { FC } from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';

import { ArrowRightIcon } from '@/assets';
import { ListItem } from '@/features/list/components/ListItem';
import { ListSection } from '@/features/list/components/ListSection';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { useAppTheme } from '@/styles/hooks/useAppTheme';

export const OrganizationManagementScreen: FC = () => {
  const theme = useAppTheme();
  const { t } = useTranslation(LocalizationNameSpace.PROFILE_SETTING, {
    keyPrefix: 'screens.organization-management'
  });

  const styles = useMemo(() => makeStyles(), []);

  return (
    <ListSection title={t('title')} style={styles.section}>
      <ListItem
        title={t('members')}
        arrowIcon={ArrowRightIcon}
        backgroundColor={theme.colors.surfaceContainerLowest}
      />
      <ListItem
        title={t('statistics')}
        arrowIcon={ArrowRightIcon}
        backgroundColor={theme.colors.surfaceContainerLowest}
      />
    </ListSection>
  );
};

const makeStyles = () =>
  StyleSheet.create({
    section: { backgroundColor: 'transparent' }
  });
